import React, { useState, useEffect } from "react";
import { useIntl } from "react-intl";
import { Button } from "@masterteam/mt-design-react";
import EditForm from "./EditForm";
import NewTable from "../NewTable";
import AdminPage from "../AdminPage";
import DeleteModal from "../DeleteModal";

import api from "../../providers/api";
import { addToast } from "../../helpers";

import { ReactComponent as EditIcon } from "../../assets/images/edit.svg";
import { ReactComponent as DeleteIcon } from "../../assets/images/delete.svg";


const initialModalState = {
  isOpen: false,
  data: null,
};

const InitiativesPage = () => {
  const intl = useIntl();
  const isAr = intl.locale === "ar";
  const [initiatives, setInitiatives] = useState([])
  const [loading, setLoading] = useState(false)
  const [isPostedData, setIsPostedData] = useState(false)


  const [formModal, setFormModal] = useState(initialModalState);
  const [deleteModal, setDeleteModal] = useState(initialModalState);
  const [deleteLoading, setDeleteLoading] = useState(false);
  const getData = () => {
    setLoading(true);
    api.initiatives
      .getAllInitiatives()
      .then((res) => {
        setInitiatives(res.StatusCode === "Success" ? res.Data : [])
      })
      .finally(() => {
        setLoading(false);
      });
  };
  useEffect(() => {
      getData()
  }, []);
  useEffect(() => {
    if(isPostedData){
      getData()
    }
  }, [isPostedData]);
  const handleDelete = (id) => {
    setDeleteLoading(true);
  setIsPostedData(false);
    api.initiatives
      .delete(id)
      .then((res) => {
        const { StatusCode, StatusMessage } = res;
        if (StatusCode === "Success") {
          setDeleteModal(initialModalState);
          setIsPostedData(true);
          addToast.success("toast.successDelete");
        } else if (StatusCode === "fail") {
          addToast.error(StatusMessage, {
            toastId: "get-users-error",
          });
        }
      })
      .catch((error) => {
        addToast.error(error.message, {
          toastId: "get-users-error",
        });
      })
      .finally(() => {
        setDeleteLoading(false);
      });
  };

  return (
    <AdminPage
      title={intl.formatMessage({ id: "common.initiatives" })}
      loading={loading}
    >
      <div
        style={{
          width: "40%",
        }}
      >
        <NewTable
          data={initiatives}
          actionsHeader={
            <Button
              fixed
              onClick={() => setFormModal({ isOpen: true, data: null })}
            >
              {intl.formatMessage({ id: "common.add" })}
            </Button>
          }
          columns={[
            {
              key: "Initiative Name",
              header: intl.formatMessage({
                id: "initiative.name",
              }),
              cell: (item) => (isAr ? item.ArabicName : item.EnglishName),
              width: "60%",
            },
            {
              key: "Initiative Code",
              header: intl.formatMessage({ id: "initiative.code" }),
              cell: (item) =>  item?.Code,
              width: "40%",
            },
          ]}
          actions={[
            {
              key: "edit",
              variant: "primary",
              Icon: EditIcon,
              "tooltip-position": "buttom",
              tooltip: intl.formatMessage({ id: "common.update" }),
              onClick: (item) => {
                setFormModal({ isOpen: true, data: item });
              },
            },
            {
              key: "delete",
              variant: "error",
              Icon: DeleteIcon,
              "tooltip-position": "buttom",
              tooltip: intl.formatMessage({ id: "common.delete" }),
              onClick: (item) => {
                setDeleteModal({ isOpen: true, data: item.ID });
              },
            },
          ]}
          compact
        />
      </div>

      {formModal.isOpen ? (
        <EditForm
          data={formModal.data}
          closeModal={() => setFormModal(initialModalState)}
          setIsPostedData={setIsPostedData}
        />
      ) : null}

      {deleteModal.isOpen ? (
        <DeleteModal
          isOpen={deleteModal.isOpen}
          title={intl.formatMessage({ id: "common.initiative" })}
          closeModal={() => setDeleteModal(initialModalState)}
          handleDelete={() => handleDelete(deleteModal.data)}
          ButtonStatus={deleteLoading}
          customMessage={intl.formatMessage({ id: "common.delete-message-initiative" })}
        />
      ) : null}
    </AdminPage>
  );
};

export default InitiativesPage;
